// extracted by mini-css-extract-plugin
export default {"text-color-light":"#707070","textColorLight":"#707070","from":"LG5qk _2PcaX KbmUc"};